import { partitionAndFind } from "@omni/utils/object.utils";

import { SearchState } from "@/redux/modules/value/search/search.types";
import { SearchComponentEnum } from "@/utils/search/types/searchComponent";
import {
    SearchComponentConfiguration,
    SearchComponentConfigurationMap
} from "@/utils/search/types/searchConfiguration";

const getComponentConfigurationAndOthers = <
    TComponent extends SearchComponentEnum
>(
    searchState: SearchState,
    component: TComponent
): {
    componentConfiguration: SearchComponentConfigurationMap[TComponent];
    otherComponentConfigurations: ReadonlyArray<SearchComponentConfiguration>;
} => {
    const [configurationComponent, otherComponents] = partitionAndFind(
        searchState.configuration.components,
        (configurationComponent) =>
            configurationComponent.component === component
    );

    return {
        componentConfiguration:
            configurationComponent as SearchComponentConfigurationMap[TComponent],
        otherComponentConfigurations: otherComponents
    };
};

export { getComponentConfigurationAndOthers };
